import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, CardContent, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { IconClipboardList, IconPlus, IconTrash } from '@tabler/icons';
import { useHistory } from 'react-router-dom';
import api from '../../../../services/api';
import PageHeader from '../../../../../ui-component/extended/PageHeader';
import GlassCard from '../../../../../ui-component/extended/GlassCard';

const BillOfMaterialsList = () => {
    const history = useHistory();
    const [appId, setAppId] = useState(null);
    const [boms, setBoms] = useState([]);
    const [status, setStatus] = useState({ type: '', message: '' });

    useEffect(() => {
        (async () => {
            try {
                const res = await api.get('v1/apps/default/');
                setAppId(res.data.app.id);
            } catch (error) {
                console.error(error);
            }
        })();
    }, []);

    useEffect(() => {
        if (!appId) return;
        loadBoms();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId]);

    const loadBoms = async () => {
        try {
            const res = await api.get(`v1/apps/${appId}/boms/`);
            setBoms(res.data.boms || []);
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'Erro ao carregar fichas técnicas' });
        }
    };

    const handleDelete = async (bom) => {
        if (!window.confirm(`Excluir a ficha técnica "${bom.name}"?`)) return;
        try {
            await api.delete(`v1/apps/${appId}/boms/${bom.id}/`);
            setBoms((prev) => prev.filter((b) => b.id !== bom.id));
        } catch (error) {
            console.error(error);
            setStatus({ type: 'error', message: 'Erro ao excluir ficha técnica' });
        }
    };

    return (
        <Box>
            <PageHeader
                icon={IconClipboardList}
                gradient="blue"
                title="Fichas Técnicas"
                subtitle="Receitas de produção (BOM)"
                actions={
                    <Button
                        variant="contained"
                        startIcon={<IconPlus size={18} />}
                        onClick={() => history.push('/dashboard/production/bom/new')}
                    >
                        Nova Ficha Técnica
                    </Button>
                }
            />

            {status.message && (
                <Alert severity={status.type} sx={{ mb: 2 }} onClose={() => setStatus({ type: '', message: '' })}>
                    {status.message}
                </Alert>
            )}

            <GlassCard>
                <CardContent>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Nome</TableCell>
                                <TableCell>Produto final</TableCell>
                                <TableCell>Rendimento</TableCell>
                                <TableCell align="right" />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {boms.map((bom) => (
                                <TableRow key={bom.id} hover>
                                    <TableCell>{bom.name}</TableCell>
                                    <TableCell>{bom.produto_variacao_name}</TableCell>
                                    <TableCell>{bom.output_quantity}</TableCell>
                                    <TableCell align="right">
                                        <IconButton size="small" onClick={() => handleDelete(bom)}>
                                            <IconTrash size={16} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {boms.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={4} align="center">
                                        Nenhuma ficha técnica cadastrada ainda
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </CardContent>
            </GlassCard>
        </Box>
    );
};

export default BillOfMaterialsList;
